module.exports = __webpack_public_path__ + "r-v3/img/setting_white.cd9c7d86.svg";